import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import { AttachmentForm } from '../../../types/transaction';
import { ATTACHMENT_FORMS } from '../../../constants/attachments';

interface AttachmentFormSelectProps {
  value: AttachmentForm;
  onChange: (value: AttachmentForm) => void;
  disabled?: boolean;
}

export function AttachmentFormSelect({ value, onChange, disabled }: AttachmentFormSelectProps) {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Selecione a forma" />
      </SelectTrigger>
      <SelectContent>
        {ATTACHMENT_FORMS.map((form) => (
          <SelectItem key={form.value} value={form.value}>
            {form.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
